module.exports = __webpack_public_path__ + "img/banner_bg.58708dd5.png";